<template>
    <DefaultLayout :meta="meta">

        <section class="md:mt-8">
            <div class="w-full max-w-screen-xl mx-auto px-6">
                <div class="h-auto grid grid-cols-1 md:grid-cols-2 gap-y-12">
                    <div class="h-auto order-2 md:order-1">
                        <div class="w-full md:w-2/3 h-full mx-auto flex flex-col items-center justify-center">
                            <h1 class="text-2xl md:text-3xl font-bold uppercase text-center">{{ __('home::index.hero_title') }}</h1>
                            <p class="mt-6 md:mt-8 text-center whitespace-pre-line">{{ __('home::index.hero_description') }}</p>

                            <div
                                class="px-4 py-2 rounded-sm shadow-sm font-bold text-center mt-6 whitespace-pre-line"
                                :class="[$page.props.__site.promotion_style === 'black_friday'
                                    ? 'text-black bg-[#ffd732]'
                                    : 'text-primary bg-primary-light']"
                                v-if="! delayedPaymentDays"
                                v-html="__('home::index.price_info')"
                            />

                            <CTA :href="$route('home::orders.create')" variant="large" class="mt-8">
                                {{ __('home::index.order_now') }}
                                <ChevronRightIcon class="h-4 w-4 ml-2" />
                            </CTA>
                        </div>
                    </div>
                    <div class="order-1 md:order-2">
                        <img src="/media/hero.jpg" alt="Fototiles" width="750" height="750" class="w-full h-auto" />
                    </div>
                </div>
            </div>
        </section>

        <!--
        <section>
            <div class="w-full max-w-screen-xl mx-auto px-6">
                <TrustBox />
            </div>
        </section>
        -->

        <USPSection class="border-t border-b border-gray-200" />

        <SliderSection class="border-b border-gray-200" />

        <section class="py-16">
            <div class="w-full max-w-screen-xl mx-auto px-6">
                <h2 class="text-2xl font-bold text-center mb-16">
                    {{ __('home::index.see_how_easy_it_is') }}
                </h2>

                <div class="video-wrapper">
                    <video muted playsinline controls ref="video">
                        <source :src="'/media/' + $page.props.__media_folder + '/hero-video3.mp4'" type="video/mp4">
                    </video>
                </div>
            </div>
        </section>

        <ProductSection
            shape="3"
            image="/media/home-square.png"
            imageAlt="Squares"
            :title="__('home::index.product_section_3_title')"
            :description="__('home::index.product_section_3_description')"
            :price="__('home::index.product_section_3_price')"
            :cta-text="__('home::index.order_photowall_now')"
            class="mt-8"
            image-position="left"
        />

        <ProductSection
            shape="1"
            image="/media/home-hexagon.png"
            imageAlt="Hexagons"
            :title="__('home::index.product_section_2_title')"
            :description="__('home::index.product_section_2_description')"
            :price="__('home::index.product_section_2_price')"
            :cta-text="__('home::index.order_photowall_now')"
            class="bg-gray-50"
            image-position="right"
        />

        <!--
        <ProductSection
            shape="9"
            image="/media/index-frames.png"
            imageAlt="Frames"
            :title="__('home::index.product_section_1_title')"
            :description="__('home::index.product_section_1_description')"
            :price="__('home::index.product_section_1_price')"
            :cta-text="__('home::index.order_photowall_now')"
            cta-text="Lav din billedvæg nu"
            image-position="left"
        />
        -->

        <ProductGuideSection />

        <Faq class="mb-16 pt-16 border-t border-gray-200" />

    </DefaultLayout>
</template>

<script>
    import {
        ChevronRightIcon,
    } from '@heroicons/vue/outline'

    export default {
        components: {
            ChevronRightIcon,
        },
        props: {
            meta: {
                type: Object,
                default: () => {},
            },
        },
        mounted() {
            document.addEventListener('scroll', this.startVideoWhenInViewport);
        },
        beforeUnmount() {
            document.removeEventListener('scroll', this.startVideoWhenInViewport);
        },
        methods: {
            startVideoWhenInViewport() {

                let el = this.$refs.video;
                let rect = el.getBoundingClientRect();
                let requiredOffset = 50;
                let isInViewport = (rect.top - window.innerHeight + requiredOffset) < 0 ? true : false;

                if (isInViewport) {
                    el.play();
                    document.removeEventListener('scroll', this.startVideoWhenInViewport);
                }

            },
        },
    }
</script>
